import List, { TEMPLATE_PLAN } from "./list";

function TemplatePlans() {
  return <List type={TEMPLATE_PLAN} />;
}

export default TemplatePlans;
